<template>
  <div class="container-fluid mt-3">
    <h2>Komponenten Manager {{ workLabels[workarea] }}</h2>
    <div class="row">
      <div class="col">
        <div class="btn-toolbar" role="toolbar">
          <button @click="showNewDialog" class="btn btn-primary">Neue Komponente</button>
        </div>
        <b-table class="mt-3" id="compTable" :fields="fields" :items="rows">
          <template v-slot:cell(id)="data">
            <div class="btn-group">
              <button @click="openComponent(data.item)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
              <button @click="deleteComponent(data.item)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
          </template>
        </b-table>
      </div>
      <div class="col">
        <div class="btn-toolbar" role="toolbar">
          <button @click="saveComponent" class="btn btn-primary">Speichern</button>
        </div>
        <h4 class="mt-3 mb-2">{{ editItem.label }} / {{ editItem.groupName }}</h4>
        <b-tabs>
          <b-tab title="HTML">
            <div class="wrapper" style="height:600px;">
              <AceEditor ref="editor" editorId='compeditor' lang="xml" :content="editItem.document"/>
            </div>
          </b-tab>
          <b-tab title="JavaScript">
            <div class="wrapper" style="height:600px;">
              <AceEditor ref="jseditor" editorId='jscompeditor' lang="javascript" :content="editItem.script"/>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal id="newCompDlg" title="Neue Komponente" @ok="createNewComponent">
      <div class="form-group">
          <label>Name</label>
          <input type="text" v-model="editItem.label" class="form-control"/>
      </div>
      <div class="form-group">
          <div>
            <label for="input-with-list">Gruppe</label>
            <b-form-input list="input-list" v-model="editItem.groupName" id="input-with-list"></b-form-input>
            <b-form-datalist id="input-list" :options="categories"></b-form-datalist>
          </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AceEditor from '@/components/AceEditor.vue'
import cmsdocs from '@/modules/cmsdocs.js'

export default {
  components: {
    AceEditor
  },
  data() {
    return {
      cache: {}, // backup copy for aceeditor cause in display none set/get content not working
      editItem: { "document":"","label":"" ,"groupName":""},
      rows: [],
      categories: ["Test1"],
      workarea: 'firm-ui',
      fields: [
        {"key":"label","label":"Name"},
        {"key":"groupName","label":"Kategorie"},
        {"key":"id","label":"Aktion"}
      ],
      workLabels: {
        'ihand-ui':'iHand Home',
        'firm-ui':'Firma',
        'firmuser-ui':'Firmen Mitarbeiter',
        'ihanduser-ui':'iHand Vertreter',
        'ihandcustomer-ui':'iHand Kunden'
      }
    }
  },
  mounted() {
    if (this.$route.params.area) {
      this.workarea = this.$route.params.area;
    }
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      cmsdocs.listhtmlcomponents(this.workarea).then(function(data) {
        self.rows = data;
        self.categories = [...new Set(data.map(e => e.groupName))];
      }).catch(function(err) {
        self.$bvToast.toast('Fehler beim Laden der Komponenten für: ' + this.workarea + '(' + err + ')',{variant:'error',title:'Komponenten'});
      });
    },
    updateEditor(idx) {
      console.log(idx);
      if (idx == 0) {
        this.$refs.editor.setContent(this.editItem.document);
      } else {
        this.$refs.jseditor.setContent(this.editItem.script);
      }
    },
    showNewDialog() {
      this.editItem = {};
      this.$bvModal.show('newCompDlg');
    },
    createNewComponent() {
      if (this.editItem.label === '') {
        this.$bvToast.toast('Bitte geben Sie zuerst einen Namen ein.',{variant:'warning',title:'Komponenten'});
        return;
      }
      if (this.editItem.groupName === '') {
        this.$bvToast.toast('Bitte geben Sie zuerst einen Kategorie-Namen ein.',{variant:'warning',title:'Komponenten'});
        return;
      }

      this.editItem.id = this.editItem.label + '_' + this.editItem.groupName;
      this.editItem.document = '<span>Neue Komponente</span>';
      this.editItem.locale = 'de';
      this.editItem.docTree = this.workarea;

      this.$refs.editor.setContent(this.editItem.document);
      this.$refs.jseditor.setContent('');

    },
    saveComponent() {
      if (!this.editItem.id) {
        this.$bvToast.toast('Bitte zuerst eine Komponente zur Bearbeitung auswählen.',{variant:'warning',title:'Komponenten'});
        return;
      }

      this.editItem.document = this.$refs.editor.getContent();
      this.editItem.script   = this.$refs.jseditor.getContent();

      var self = this;
      fetch('/trendshop.proxy.web/rest/cms/htmlcomponents/',{method:'POST',body:JSON.stringify(this.editItem),credentials:'include'}).then(function(resp) {
        if (resp.status < 300) {
          self.$bvToast.toast('Gespeichert.',{variant:'success',title:'Komponenten'});
        } else {
          resp.text().then(function(text) {
            this.$bvToast.toast('Fehler beim Speichern der Komponente: ' + text,{variant:'error',title:'Komponenten'});
          })
        }
      }).catch(function(err) {
        self.$bvToast.toast('Fehler beim Speichern der Komponente:' + err,{variant:'error',title:'Komponenten'});
      })
    },
    openComponent(item) {
      this.editItem = item;
      this.$refs.editor.setContent(this.editItem.document);
      this.$refs.jseditor.setContent(this.editItem.script);
    },
    deleteComponent(item) {
      if (!confirm('Möchten Sie die Komponente "' + item.label + '" wirklich löschen?'))
        return;

      var self = this;
      fetch('/trendshop.proxy.web/rest/cms/htmlcomponents/' + encodeURIComponent(this.workarea) + '/' + encodeURIComponent(item.id),{method:'DELETE'}).then(function() {
        self.$bvToast.toast('Komponente wurde gelöscht.',{variant:'success',title: 'Komponenten'});
        self.fetchData();
      });
    }
  }
}
</script>
